import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'emm-add-option-dialog',
    templateUrl: './add-option-dialog.component.html',
    styleUrl: './add-option-dialog.component.scss',
    standalone: false
})
export class AddOptionDialogComponent implements OnInit {
    optionsToolTip = 'The following special characters are allowed: ! - _ &';
    specialCharactersFound = false;
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<AddOptionDialogComponent>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.form = this.formBuilder.group({
            options: new FormControl(null),
        });
    }

    optionsValidation() {
        const pattern = new RegExp( /[`~@#$%^*(){}\[\]+=\\\/|:;'".<>?]/);
        if (pattern.test(this.form?.controls['options']?.value)) {
            this.specialCharactersFound = true;
            return this.form?.controls['options']?.setErrors({pattern: true, message: ''});
        } else {
            this.specialCharactersFound = false;
            return this.form?.controls['options']?.setErrors(null);
        }
    }

    onNoClick() {
        this.dialogRef.close(false);
    }

    continue() {
        this.dialogRef.close(this.form?.controls?.options?.value)
    }
}
